import { UI_CONST } from "@Modules/ui_module/display";
import { UIModule } from "@Modules/ui_module/ui.module";
import { Logger, LoggerService } from "@Shared/logger";
export class Alert{
    private Logger: Logger = LoggerService.createLogger("Alert");

    constructor() {        
        this.Logger.trace("****  CTOR ****");
    }

    public error(message: string): void {
        this.Logger.trace("error", message);
        this.show("danger", message);
    }

    public success(message: string): void {
        this.Logger.trace("error", message);
        this.show("primary", message);
    }

    public hide(): void {
        this.Logger.trace("hide");
        const alertSection = document.querySelector('.alert');
        if (!alertSection) {            
            return;
        }
        alertSection.classList.add('visually-hidden');
    }

    public getMessage(): string {
        const alertSection = document.querySelector('.alert');
        if (!alertSection || alertSection.classList.contains('visually-hidden')) {
            return '';
        }
        return alertSection.textContent?.trim() ?? '';
    }


    private show(_type: string, _message:string): void {
        this.checkIfAdded();
        const alertSection = document.querySelector('.alert');
        if (!alertSection) {
            this.Logger.warn("Element with class 'mng-alert-section' not found.");("Element with class 'alert' not found.");
            return;
        }
        alertSection.classList.add(`alert-${_type}`);
        alertSection.classList.remove('visually-hidden');
        alertSection.innerHTML = _message;
        
    }

    private checkIfAdded(): void {        
        const alertSection = document.querySelector(UI_CONST.alertSection);
        if (!alertSection) {
            this.Logger.warn("Element with class 'mng-alert-section' not found.");
            return;
        }
        alertSection.innerHTML = UIModule.HTML.alert;
    }

}